module.exports = __webpack_public_path__ + "img/BecomePan-5.04bce52f.svg";